<div class="cm-ui-style-container">
    <div [matMenuTriggerFor]="uiStyleMenu" class="cm-ui-style-selector">
        <div>UI Style: {{ labelForUiStyle($uiStyle()) }}</div>
        <i class="far fa-chevron-down"></i>
        <mat-menu #uiStyleMenu>
            <div>
                @for (option of availableUiStyles; track option.value) {
                    <button mat-menu-item (click)="$uiStyle.set(option.value)" [class.cm-active]="$uiStyle() === option.value" class="cm-ui-style-button">
                        {{ option.label }}
                    </button>
                }
            </div>
        </mat-menu>
    </div>
    @if ($uiStyle() === "accordion") {
        <div [matMenuTriggerFor]="accordionStyleMenu" class="cm-ui-style-selector">
            <div>Accordion: {{ labelForAccordionStyle($accordionStyle()) }}</div>
            <i class="far fa-chevron-down"></i>
            <mat-menu #accordionStyleMenu>
                <div>
                    @for (option of availableAccordionStyles; track option.value) {
                        <button
                            mat-menu-item
                            (click)="$accordionStyle.set(option.value)"
                            [class.cm-active]="$accordionStyle() === option.value"
                            class="cm-ui-style-button"
                        >
                            {{ option.label }}
                        </button>
                    }
                </div>
            </mat-menu>
        </div>
    }
</div>
<cm-config-menu [externalMenu]="true" [uiStyle]="$uiStyle()" [accordionStyle]="$accordionStyle()"></cm-config-menu>
